/** UI texts: app shell, navigation, sign-in. Each key must exist in both languages. */
export const shell = {
  en: {
    "nav.admin": "admin",
    "nav.signOut": "Sign out",
    "auth.setupTitle": "Set up your platform",
    "auth.setupIntro": "The first account becomes the administrator. Everything else is configured inside the app.",
    "auth.name": "Name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.passwordHint": "At least 10 characters.",
    "auth.domain": "Domain (optional)",
    "auth.domainHint": "The address this installation will answer under, e.g. trading.example.com — point its A record to this server; HTTPS comes by itself. Can also be set later under Settings → Domain.",
    "auth.wait": "Please wait…",
    "auth.signIn": "Sign in",
    "auth.createAccount": "Create account",
    "auth.register": "Register",
    "auth.switch": "Sign in or register",
    "auth.slogan": "Read markets. Share trades. Vote together.",
    "auth.copyright": "© 2026 {app}. All rights reserved.",
    "auth.genericError": "Something went wrong",
    "auth.closed.title": "Limited access",
    "auth.closed.intro": "{app} is opening its doors step by step.",
    "auth.closed.body": "Right now only a small circle of traders works with {app}. Together we sharpen the analyses, models and tools before more places open up — that's why new registrations aren't possible at the moment.",
    "auth.closed.soon": "New places are released gradually — check back soon.",
    "auth.closed.member": "Already in? Sign in",
    "page.signIn": "Sign in",
    "page.register": "Create account",
  } as Record<string, string>,
  de: {
    "nav.admin": "Admin",
    "nav.signOut": "Abmelden",
    "auth.setupTitle": "Plattform einrichten",
    "auth.setupIntro": "Das erste Konto wird Administrator. Alles Weitere wird direkt in der App eingerichtet.",
    "auth.name": "Name",
    "auth.email": "E-Mail",
    "auth.password": "Passwort",
    "auth.passwordHint": "Mindestens 10 Zeichen.",
    "auth.domain": "Domain (optional)",
    "auth.domainHint": "Die Adresse dieser Installation, z. B. trading.beispiel.de – ihren A-Eintrag auf diesen Server setzen; HTTPS kommt von selbst. Auch später unter Einstellungen → Domain möglich.",
    "auth.wait": "Bitte warten …",
    "auth.signIn": "Anmelden",
    "auth.createAccount": "Konto erstellen",
    "auth.register": "Registrieren",
    "auth.switch": "Anmelden oder registrieren",
    "auth.slogan": "Märkte lesen. Trades teilen. Gemeinsam abstimmen.",
    "auth.copyright": "© 2026 {app}. Alle Rechte vorbehalten.",
    "auth.genericError": "Etwas ist schiefgelaufen",
    "auth.closed.title": "Zugang derzeit limitiert",
    "auth.closed.intro": "{app} öffnet seine Türen Schritt für Schritt.",
    "auth.closed.body": "Im Moment arbeitet nur ein kleiner Kreis von Tradern mit {app}. Gemeinsam schärfen wir Analysen, Modelle und Werkzeuge, bevor weitere Plätze frei werden – deshalb sind neue Registrierungen gerade nicht möglich.",
    "auth.closed.soon": "Neue Plätze werden nach und nach freigegeben – schau bald wieder vorbei.",
    "auth.closed.member": "Schon dabei? Anmelden",
    "page.signIn": "Anmelden",
    "page.register": "Konto erstellen",
  } as Record<string, string>,
};
